import { useCallback, useState } from "react";
import type { Dayjs } from "dayjs";
import { useNavigationQuery } from "./NavigationQueryProvider";
import { dateRangeQuery } from "./queryCodecs";

type DateRange = [Dayjs | null, Dayjs | null];
export const useNavigationDateRange = (
  key: string,
  initial: () => DateRange
) => {
  const [range, setRange] = useNavigationQuery(
    key,
    initial,
    dateRangeQuery,
    "replace"
  );
  const signature = dateRangeQuery.format(range);
  const [draft, setDraft] = useState<{
    signature: string;
    range: DateRange;
  } | null>(null);
  const setPickerValue = useCallback(
    (selection: DateRange) => {
      setDraft({ signature, range: selection });
      if (
        selection[0]?.isValid() &&
        selection[1]?.isValid() &&
        selection[0].isBefore(selection[1])
      )
        setRange(selection);
    },
    [signature, setRange]
  );
  return {
    range,
    setRange,
    pickerValue: draft?.signature === signature ? draft.range : range,
    setPickerValue,
  };
};
